import moment from 'moment';

import { displayDateFormat_MMM_DD_YYYY } from '../../../../lib/constants/date-time.constants';
import {
  formatCompactMetricValue,
  getCurrencySymbolByCurrencyCodeOrSymbol,
} from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

export const formatPreviousReportDate = (date: string): string => {
  if (!date) return INVALID_VALUE;

  return moment(date).format(displayDateFormat_MMM_DD_YYYY);
};

export const formatEarningsRevenue = (revenue: string, currency: string, symbol: string): string => {
  if (!revenue) return INVALID_VALUE;

  const currencySymbol = getCurrencySymbolByCurrencyCodeOrSymbol(currency, symbol);
  return formatCompactMetricValue(revenue, { withCurrency: true, currencySymbol });
};
